import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mcb-portal-layout',
  templateUrl: './portal-layout.component.html',
})
export class PortalLayoutComponent {
  constructor() { }
}
